var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary btn-with-icon btn-md",attrs:{"type":"submit","disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('img',{staticClass:"icon left",attrs:{"src":"/pic/icon-chevron-right.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }